import { LocalisationConstants } from './localisation.constants'
import { LocalisationHelpers } from './localisation.helpers'
import { LocalisationLocale } from './localisation.locale'

export const Localisation = {
  ...LocalisationHelpers,
  ...LocalisationConstants,
  ...LocalisationLocale,
}
